import styled from 'styled-components'

export const SkeletonRoot = styled.div`
  width: min(760px, 100%);
  margin: 0 auto;
`

export const SkeletonProgress = styled.div`
  display: flex;
  gap: 10px;
  overflow: hidden;
  padding-bottom: 18px;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
`

export const SkeletonBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-top: 44px;
`

export const SkeletonActions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding-top: 22px;
  border-top: 1px solid ${p => p.theme.palette.colors.borderSoft};
`
